import Operate from './operate'
import {timeFormat} from '@/utils'

export const rewardColumn = function () {
  return [
    // {
    //   title: '年度',
    //   isEdit: true,
    //   width: 80,
    //   [$field]: 'rewardYear'
    // },
    {
      title: '获奖日期',
      width: 100,
      isEdit: true,
      [$field]: 'rewardDate',
      render (h, {row}) {
        return h('span', timeFormat(row.rewardDate))
      }
    },
    {
      title: '奖励级别',
      isEdit: true,
      width: 140,
      [$field]: 'rewardLevel'
    },
    {
      title: '奖励类别',
      isEdit: true,
      [$field]: 'levelType'
    },
    {
      title: '奖励名称',
      isEdit: true,
      [$field]: 'rewardName'
    },
    {
      title: '颁发组织',
      isEdit: true,
      [$field]: 'approvalOrgName'
    },
    {
      title: '角色',
      isEdit: true,
      width: 100,
      [$field]: 'rewardUserTypeName'
    },
    {
      title: '是否主要负责人',
      isEdit: true,
      width: 120,
      [$field]: 'rewardUserPrincipalName'
    },
    {
      'title': '操作',
      'width': 100,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': Operate
    }
  ]
}
export const punishColumn = function () {
  return [
    // {
    //   title: '年度',
    //   isEdit: true,
    //   width: 80,
    //   [$field]: 'rewardYear'
    // },
    {
      title: '惩处日期',
      width: 100,
      isEdit: true,
      [$field]: 'rewardDate',
      render (h, {row}) {
        return h('span', timeFormat(row.rewardDate))
      }
    },
    {
      title: '惩处级别',
      isEdit: true,
      width: 120,
      [$field]: 'rewardLevel'
    },
    {
      title: '惩处原因',
      isEdit: true,
      [$field]: 'rewardReasonAdded'
    },
    {
      title: '惩处结果',
      isEdit: true,
      [$field]: 'rewardName'
    },
    {
      title: '惩处批准组织',
      isEdit: true,
      [$field]: 'approvalOrgName'
    },
    {
      'title': '操作',
      'width': 100,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': Operate
    }
  ]
}
export const personColumn = function () {
  return [
    {
      title: '惩处原因',
      isEdit: true,
      [$field]: 'rewardReasonAdded'
    },
    {
      title: '惩处日期',
      width: 120,
      isEdit: true,
      [$field]: 'rewardDate',
      render (h, {row}) {
        return h('span', timeFormat(row.rewardDate))
      }
    },
    {
      title: '惩处级别',
      isEdit: true,
      width: 120,
      [$field]: 'rewardLevel'
    },
    {
      title: '惩处批准组织',
      isEdit: true,
      [$field]: 'approvalOrgName'
    },
    {
      title: '惩处结果',
      isEdit: true,
      [$field]: 'rewardName'
    },
    {
      'title': '操作',
      'width': 100,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': Operate
    }
  ]
}
